import { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL } from '../config';
import Spinner from '../components/Spinner';

export default function GuestUnregisterPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [hike, setHike] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchHike = async () => {
      try {
        const response = await fetch(`${API_URL}/hikes/${id}`);
        if (!response.ok) {
          throw new Error('Gita non trovata');
        }
        const data = await response.json();
        setHike(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchHike();
  }, [id]);

  const handleUnregister = async () => {
    setIsSubmitting(true);
    setError('');
    
    try {
      const response = await fetch(`${API_URL}/hikes/${id}/guest-unregister?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Errore durante l\'annullamento dell\'iscrizione');
      }
      
      setSuccess(true);
      setIsSubmitting(false);
    } catch (err) {
      setError(err.message);
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full mx-4 text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-4">Errore</h2>
          <p className="text-gray-700 mb-6">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
          >
            Torna alla homepage
          </button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full mx-4 text-center">
          <h2 className="text-xl font-semibold text-green-600 mb-4">Iscrizione annullata!</h2>
          <p className="text-gray-700 mb-6">
            La tua iscrizione alla gita è stata annullata con successo.
          </p>
          <button
            onClick={() => navigate('/')}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
          >
            Torna alla homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-2xl mx-auto p-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Annulla iscrizione</h1>
          
          {hike && (
            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
              <h3 className="font-semibold text-gray-800 mb-2">{hike.titolo}</h3>
              <p className="text-sm text-gray-600">{hike.data_inizio}</p>
              {hike.luogo && <p className="text-sm text-gray-600">{hike.luogo}</p>}
            </div>
          )}

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md mb-6">
            <p className="text-sm text-yellow-800">
              <strong>Attenzione:</strong> Stai per annullare la tua iscrizione a questa gita.
              Questa azione non può essere annullata.
            </p>
          </div>

          {error && <div className="p-3 bg-red-50 border-l-4 border-red-400 text-red-700 text-sm mb-4">{error}</div>}

          <button
            type="button"
            onClick={handleUnregister}
            disabled={isSubmitting}
            className="w-full bg-red-600 text-white py-3 px-4 rounded-md font-semibold hover:bg-red-700 transition disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {isSubmitting ? <><Spinner size="sm" color="white" /> Caricamento...</> : 'Annulla iscrizione'}
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full mt-3 bg-gray-200 text-gray-700 py-3 px-4 rounded-md font-semibold hover:bg-gray-300 transition"
          >
            Torna indietro
          </button>
        </div>
      </div>
    </div>
  );
}
